import { axiosInstance, axiosNodeInstance } from "./config"
import secureLocalStorage from "react-secure-storage"

const LOGIN_API = /\/(auth\/)?login\/?(\?|$)/
const isLoginApi = apiName => LOGIN_API.test(`/${apiName || ""}`)

// Every node API sends token except login. Falls back to stored token when caller passes ''/undefined.
const resolveToken = (token, apiName) => {
  if (isLoginApi(apiName)) return null
  return token || secureLocalStorage.getItem("auth_token")
}

const authHeaders = (token, apiName) => {
  const resolved = resolveToken(token, apiName)
  return resolved ? { Authorization: `Bearer ${resolved}` } : {}
}

export const fetchData = async (toggleLoading, apiName, token) => {
  try {
    if (toggleLoading) toggleLoading(true)
    const res = await axiosInstance.get(`/${apiName}`, {
      headers: {
        ...authHeaders(token, apiName),
      },
    })
    if (toggleLoading) toggleLoading(false)
    return res.data
  } catch (error) {
    console.error(error)
    if (toggleLoading) toggleLoading(false)
  }
}
export const fetchNodeData = async (toggleLoading, apiName, token) => {
  try {
    if (toggleLoading) toggleLoading(true)
    const res = await axiosNodeInstance.get(`/${apiName}`, {
      headers: {
        ...authHeaders(token, apiName),
      },
    })
    if (toggleLoading) toggleLoading(false)
    return res.data
  } catch (error) {
    console.error(error)
    if (toggleLoading) toggleLoading(false)
  }
}

export const FetchPostData = async (
  toggleLoading,
  apiName,
  token,
  formDataEntries
) => {
  try {
    if (toggleLoading) toggleLoading(true)
    const formData = new FormData()
    for (const [key, value] of Object.entries(formDataEntries || {})) {
      formData.append(key, value)
    }
    const res = await axiosInstance.post(`${apiName}`, formDataEntries, {
      headers: {
        ...authHeaders(token, apiName),
      },
    })
    if (toggleLoading) toggleLoading(false)
    return res
  } catch (error) {
    console.error(error)
    if (toggleLoading) toggleLoading(false)
    return error?.response || error
  }
}
export const FetchNodePostData = async (
  toggleLoading,
  apiName,
  token,
  formDataEntries
) => {
  try {
    if (toggleLoading) toggleLoading(true)
    const formData = new FormData()
    for (const [key, value] of Object.entries(formDataEntries || {})) {
      formData.append(key, value)
    }
    const res = await axiosNodeInstance.post(`${apiName}`, formDataEntries, {
      headers: {
        ...authHeaders(token, apiName),
      },
    })
    if (toggleLoading) toggleLoading(false)
    return res
  } catch (error) {
    console.error(error)
    if (toggleLoading) toggleLoading(false)
    return error?.response || error
  }
}
// PUT - Update
export const FetchNodePutData = async (
  toggleLoading,
  nodeUrl,
  id,
  formDataEntries,
  token
) => {
  try {
    if (toggleLoading) toggleLoading(true)
    const apiName = `${nodeUrl}/${id}`
    const res = await axiosNodeInstance.put(
      `/${apiName}`,
      formDataEntries,
      {
        headers: {
          "Content-Type": "application/json",
          ...authHeaders(token, apiName),
        },
      }
    )
    if (toggleLoading) toggleLoading(false)
    return res
  } catch (error) {
    console.error(error)
    if (toggleLoading) toggleLoading(false)
    return error?.response || error
  }
}

// DELETE - Remove
export const FetchNodeDeleteData = async (toggleLoading, nodeUrl, id, token) => {
  try {
    if (toggleLoading) toggleLoading(true)
    const apiName = `${nodeUrl}/${id}`
    const res = await axiosNodeInstance.delete(`/${apiName}`, {
      headers: {
        ...authHeaders(token, apiName),
      },
    })
    if (toggleLoading) toggleLoading(false)
    return res
  } catch (error) {
    console.error(error)
    if (toggleLoading) toggleLoading(false)
    return error?.response || error
  }
}
